import {mapStyle} from './mapStyle';

export default class Map {
    constructor(el, cords) {
        this.el = el;
        this.cords = cords;
        this.mapHolder = this.el.querySelector('.map__holder');
        this.gmap = false;
        this.markers = [];
        this.centerMarkers = false;

        this.settings = this.setSettings();
        this.mapIcon = this.setMapIcon();
        this.createMap();
    }

    setSettings() {
        let position = window.google.maps.ControlPosition.RIGHT_BOTTOM;

        return {
            draggable: true,
            zoom: 7,
            maxZoom: false,
            mapTypeId: window.google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true,
            scrollwheel: false,
            zoomControl: true,
            zoomControlOptions: {
                position: position
            },
            styles: mapStyle
        };
    }

    setMapIcon() {
        let windowWidth = window.innerWidth;
        var width = 75;
        var height = 100;

        if (windowWidth <= 760) {
            width = 50;
            height = 67;
        }

        return {
            url: window.pinIcons[0],
            size: new window.google.maps.Size(width, height),
            scaledSize: new window.google.maps.Size(width, height),
            origin: new window.google.maps.Point(0, 0),
            anchor: new window.google.maps.Point(width / 2, height)
        };
    }

    createMap() {
        this.gmap = new window.google.maps.Map(this.mapHolder, {
            zoom: this.settings.zoom,
            center: new window.google.maps.LatLng(this.cords[0]['lat'], this.cords[0]['lng']),
            maxZoom: this.settings.maxZoom,
            draggable: this.settings.draggable,
            mapTypeId: this.settings.mapTypeId,
            disableDefaultUI: this.settings.disableDefaultUI,
            scrollwheel: this.settings.scrollwheel,
            zoomControl: this.settings.zoomControl,
            zoomControlOptions: this.settings.zoomControlOptions,
            styles: this.settings.styles
        });

        this.addOverlay();
        this.buildMarkers();
    }

    addOverlay() {
        const donut = new window.google.maps.Polygon({
            paths: [
                [
                    new window.google.maps.LatLng(-87, 120),
                    new window.google.maps.LatLng(-87, -87),
                    new window.google.maps.LatLng(-87, 0)
                ],
                drawCircle(new window.google.maps.LatLng(42, -80), 1000, -1)
            ],
            strokeColor: '#000000',
            strokeOpacity: 0.6,
            strokeWeight: 2,
            fillColor: '#00457c',
            fillOpacity: 0.2
        });
        donut.setMap(this.gmap);
    }

    buildMarkers() {
        for (let i = 0; i < this.cords.length; i++) {
            let marker = this.buildMarker(this.cords[i]['lat'], this.cords[i]['lng']);
            this.markers.push(marker);
        }

        if (this.centerMarkers) {
            this.fitMarkers();
        }
    }

    buildMarker(lat, lng) {
        const marker = new window.google.maps.Marker({
            position: new window.google.maps.LatLng(lat, lng),
            map: this.gmap,
            icon: this.mapIcon,
            animation: window.google.maps.Animation.DROP,
            zIndex: 99,
            optimized: false
        });
        return marker;
    }

    fitMarkers() {
        let bounds = new window.google.maps.LatLngBounds();
        for (let i = 0; i < this.markers.length; i++) {
            bounds.extend(this.markers[i].getPosition());
        }

        this.gmap.initialZoom = true;
        this.gmap.fitBounds(bounds);
        this.gmap.panBy(0, -25);
    }
}

function drawCircle(point, radius, dir) {
    var d2r = Math.PI / 180;
    var r2d = 180 / Math.PI;
    var earthsradius = 3963;
    var points = 25;
    var rlat = (radius / earthsradius) * r2d;
    var rlng = rlat / Math.cos(point.lat() * d2r);
    var extp = [];
    var end = 0;
    var start = 0;

    if (dir === 1) {
        start = 0;
        end = points + 1;
    } else {
        start = points + 1;
        end = 0;
    }

    for (var i = start; (dir === 1 ? i < end : i > end); i = i + dir) {
        var theta = Math.PI * (i / (points / 2));
        let ey = point.lng() + (rlng * Math.cos(theta));
        let ex = point.lat() + (rlat * Math.sin(theta));
        extp.push(new window.google.maps.LatLng(ex, ey));
    }

    return extp;
}



// WEBPACK FOOTER //
// ./src/components/map/map.js